const setCookie = (name, value, days) => {
  let expires = "";
  if (days > 0) {
    const date = new Date();
    date.setTime(Date.now() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  const sameSiteLax = (process.env.environment === 'production') ? '; SameSite=Lax' : '';
  document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/" + sameSiteLax;
};
const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^|; )" + name + "=([^;]*)"));
  return match !== undefined && match !== null ? decodeURIComponent(match[2]) : "";
};

export const setDarkMode = (toggle) => {
  if (toggle === true) {
    document.documentElement.classList.add("dark");
    setCookie("color-theme", "dark", 365);
  } else {
    document.documentElement.classList.remove("dark");
    setCookie("color-theme", "light", 365);
  }
};

export const loadDarkMode = () => {
  const theme = getCookie("color-theme");

  if (theme === "dark") {
    document.documentElement.classList.add("dark");
    return true;
  }

  if (theme === "light") {
    document.documentElement.classList.remove("dark");
    return false;
  }

  document.documentElement.classList.remove("dark");
  setCookie("color-theme", "light", 365);
  return false;
};

